import mainRoute from '@input-web/modules/main/views/main/main.route';
import uiPlaygroundRoute from '@input-web/modules/main/views/ui-playground/ui-playground.route';
import standardAdditionalDetailRoute from '@input-web/modules/standard/views/additional-detail/standard-additional-detail.route';
import standardDetailLayoutRoute from '@input-web/modules/standard/views/detail-layout/standard-detail-layout.route';
import standardLayoutRoute from '@input-web/modules/standard/views/layout/standard-layout.route';
import standardListRoute from '@input-web/modules/standard/views/list/standard-list.route';
import standardQuestionDetailRoute from '@input-web/modules/standard/views/question-detail/standard-question-detail.route';
import standardScoringDetailRoute from '@input-web/modules/standard/views/scoring-detail/standard-scoring-detail.route';
import loginRoute from '@input-web/modules/user/views/login/login.route';
import { createRouter } from '@tanstack/react-router';
import envConfig from '../env/env.config';
import rootRoute from './route.root';

const routeTree = rootRoute.addChildren([
  ...(envConfig.env === 'development' ? [uiPlaygroundRoute] : []),
  mainRoute.addChildren([
    loginRoute,
    standardLayoutRoute.addChildren([
      standardListRoute,
      standardDetailLayoutRoute.addChildren([
        standardQuestionDetailRoute,
        standardAdditionalDetailRoute,
        standardScoringDetailRoute,
      ]),
    ]),
  ]),
]);

const router = createRouter({ routeTree });

export default router;
